import { useEffect, useRef, useState } from 'react';
import { DisconnectOutlined, WifiOutlined } from '@ant-design/icons';
import clsx from 'clsx';

import './styles.scss';

const RECONNECTED_VISIBILITY_MS = 4000;

const getInitialStatus = () => {
	if (typeof navigator !== 'undefined' && !navigator.onLine) {
		return 'offline';
	}

	return 'hidden';
};

const NetworkStatusBanner = () => {
	const [status, setStatus] = useState(getInitialStatus);
	const wasOfflineRef = useRef(status === 'offline');

	useEffect(() => {
		let hideTimer;

		const handleOffline = () => {
			window.clearTimeout(hideTimer);
			wasOfflineRef.current = true;
			setStatus('offline');
		};

		const handleOnline = () => {
			if (!wasOfflineRef.current) return;

			wasOfflineRef.current = false;
			setStatus('online');
			hideTimer = window.setTimeout(() => {
				setStatus('hidden');
			}, RECONNECTED_VISIBILITY_MS);
		};

		window.addEventListener('offline', handleOffline);
		window.addEventListener('online', handleOnline);

		return () => {
			window.clearTimeout(hideTimer);
			window.removeEventListener('offline', handleOffline);
			window.removeEventListener('online', handleOnline);
		};
	}, []);

	if (status === 'hidden') return null;

	const isOffline = status === 'offline';

	return (
		<div
			className={clsx('network-status-banner', {
				'network-status-banner--offline': isOffline,
				'network-status-banner--online': !isOffline,
			})}
			role={isOffline ? 'alert' : 'status'}
			aria-live={isOffline ? 'assertive' : 'polite'}
		>
			<div className="network-status-banner__icon" aria-hidden="true">
				{isOffline ? <DisconnectOutlined /> : <WifiOutlined />}
			</div>
			<div className="network-status-banner__content">
				<strong>
					{isOffline
						? 'Koneksi internet terputus'
						: 'Koneksi kembali tersambung'}
				</strong>
				<span>
					{isOffline
						? 'Jangan tutup halaman ini. Progres akan dilanjutkan setelah koneksi kembali.'
						: 'Kamu dapat melanjutkan aktivitas seperti biasa.'}
				</span>
			</div>
		</div>
	);
};

export default NetworkStatusBanner;
